module.exports = __webpack_public_path__ + "static/media/image-3.07ccef69.png";